/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/VideoBaseContent/theme';

export const VideoBaseContentTheme = theme;
